export default __webpack_public_path__ + "static/media/notfound.b8dc8607.png";